import axios from 'axios'
import { CommonFilterModel, CommonParams } from '@/api/resources/common/shared/models/common.models'
import { IResponseAgGrid } from '@/shared/models/ag-grid.model'
import {
    ConfigurationSynopticTemplateCreateRequest,
    ConfigurationSynopticTemplatePatchInBatchRequest,
    ConfigurationSynopticTemplateResponse
} from '@/modules/configurationModule/detail/templates/synoptic-templates/services/configuration-synoptic-template/configuration-synoptic-template.dto'
import { EntityIdentifiersRequest, EntityIdentifierWithErrorResponse } from '@/shared/models/http/http.model'

class ConfigurationSynopticTemplateService {
    async paginator(filterModel: CommonFilterModel | undefined, params: CommonParams | undefined, laboratoryId: number): Promise<IResponseAgGrid<ConfigurationSynopticTemplateResponse>> {
        const response = await axios.put<IResponseAgGrid<ConfigurationSynopticTemplateResponse>>(`/configuration/laboratories/${laboratoryId}/synopticTemplates`, filterModel, { params })
        return response.data
    }

    async patch(laboratoryId: number, request: ConfigurationSynopticTemplatePatchInBatchRequest[]): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.patch<EntityIdentifierWithErrorResponse[]>(`/configuration/laboratories/${laboratoryId}/synopticTemplates/batch`, request)
        return response.data
    }

    async create(laboratoryId: number, request: ConfigurationSynopticTemplateCreateRequest): Promise<ConfigurationSynopticTemplateResponse> {
        const response = await axios.post<ConfigurationSynopticTemplateResponse>(`/configuration/laboratories/${laboratoryId}/synopticTemplates`, request)
        return response.data
    }

    async delete(laboratoryId: number, request: EntityIdentifiersRequest): Promise<EntityIdentifierWithErrorResponse[]> {
        const response = await axios.delete<EntityIdentifierWithErrorResponse[]>(`/configuration/laboratories/${laboratoryId}/synopticTemplates/batch`, { data: request })
        return response.data
    }

    async get(laboratoryId: number, synopticTemplateId: number): Promise<ConfigurationSynopticTemplateResponse> {
        const response = await axios.get<ConfigurationSynopticTemplateResponse>(`/configuration/laboratories/${laboratoryId}/synopticTemplates/${synopticTemplateId}`)
        return response.data
    }
}
export const configurationSynopticTemplateService = new ConfigurationSynopticTemplateService()
